:host {
  display: contents;
}

.spw-breadcrumb-item {
  list-style: none;
  display: inline;

  &__text {
    font-weight: 700;
    color: var(--spw-color-themes-grey-grey-900);
    :host(.spw-breadcrumb-item--dark) & {
      color: var(--spw-ds-white);
    }
  }
}
